<!--suppress ALL -->
<template>
  <v-select :items="options" v-model="model" :label="label" outlined rounded dense></v-select>
</template>

<script>

import QuestionType from "root/packages/closeapp/QuestionsManager/assets/types/QuestionType";

export default {
  name: "question-type-select",
  props: { value: { default: null }, label: { default: "בחר סוג שאלה" }, gameType: { default: null } },
  data() {
    return {
      selectValue: this.value
    }
  },
  computed: {
    options() {
      const allQuestions = QuestionType.getAsOption();
      /**
       * Closed:
       * 5 - Monopol
       * 35 - Bingo
       * 3 - X/O
       * 2 - Trivia
       *
       * Open:
       * 1 - Pistohim
       * 4 - Galgal hamazal
       */


      const closedQuestionsGames = [5, 35, 3, 2];
      const openQuestionsGames = [1, 4];

      if (this.gameType) {
        if (closedQuestionsGames.includes(this.gameType.id)) {
          this.selectValue = 1;
          return allQuestions.filter(question => question.value == 1); // 1 = closed
        } else if (openQuestionsGames.includes(this.gameType.id)) {
          this.selectValue = 2;
          return allQuestions.filter(question => question.value == 2); // 2 = open
        }
      }
      return allQuestions;
    },
    model: {
      get() {
        return this.selectValue;
      },
      set(val) {
        this.$emit("input", val);
      }
    }
  }
};
</script>
